module.exports = __webpack_public_path__ + "static/icon_mixcloud-bf394b69d64582b4b072409b8e6fa73e.png";